import DOMPurify from 'dompurify';

/**
 * Renders server/upstream-supplied HTML AFTER sanitizing it with DOMPurify.
 *
 * Product/drug info (consumer folders, monographies, non-pharma info) arrives as
 * raw HTML from external databases and importers. Rendering it directly with
 * dangerouslySetInnerHTML let a poisoned record run script in the admin's
 * session (e.g. `<img src=x onerror=...>` stealing the auth token). The html
 * profile strips <script>, event handlers, and other active content while
 * keeping normal formatting tags.
 *
 * This is the ONLY place dangerouslySetInnerHTML should live — always render
 * untrusted HTML through here.
 */
export default function SafeHtml({ html, className, as: Tag = 'div' }) {
  if (html == null || html === '') return null;
  const clean = DOMPurify.sanitize(String(html), { USE_PROFILES: { html: true } });
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
